/* eslint-disable ember/no-computed-properties-in-native-classes */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { and } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import moment from 'moment';

// Proto: people.PostCountItem. The serializer renames id to itemId.
export default class PostCountBase extends Fragment {
  // Subclasses in linced-common extend this class with their own types.
  declare [Type]: string;

  @attr('string', { defaultValue: '' })
  declare itemId: string;

  @attr('number', { defaultValue: 0 })
  declare total: number;

  @attr('number', { defaultValue: 0 })
  declare published: number;

  @attr('number', { defaultValue: 0 })
  declare latestPostDate: number;

  // year is used by some post-count types to denote which year's posts they are counting.
  @attr('number', { defaultValue: 0 })
  declare year: number;

  @computed('latestPostDate')
  get daysSinceLatestPost() {
    const latest = this.latestPostDate;
    if (latest) {
      return moment().diff(moment.unix(latest), 'days');
    }
    return Infinity;
  }

  // isCurrent can be used to help determine whether this count is relevant.
  @and('latestPostDate', 'total')
  declare isCurrent: unknown;
}
